<template>
    <div class="balance">
        <div class="row" v-if="step == 0">
            <div class="col-sm-12 col-md-12 col-lg-12 mb-0">
                <div v-for="b in balances" :key="b.id">             
                    <div v-if="b.pay == 0">
                        <div class="text-center">
                            <div>          
                                <h5 class="fw-light mb-0">Importe a abonar:</h5>
                                <h4><span>{{b.currency}}</span> {{b.price}}</h4>
                                <button v-if="payCashTurns && !payCardTurns && !payMoneyTurns" class="btn btn-primary w-50 mb-2 mx-auto" @click="bot()">Pagar {{ textButton }}</button>   
                                <button v-else class="btn btn-primary w-50 mb-2 mx-auto" @click="notShow = false; payByUser(b.price, b.currency, b.pasarela, b.price, b.title, b.sellerId)">Pagar {{ textButton }}</button>
                            </div>
                        </div>
                    </div>
                </div>

            </div> 
        </div>
        <div class="form-pay-option first" v-if="step == 1">
            <div>
                <div>
                    <h4 class="text-dark">¿Cómo lo vas a abonar?</h4>
                    <button v-if="payCardTurns" class="btn btn-primary mt-2 w-100" @click="this.step = 3">Con Tarjeta de Crédito/Debito</button>
                    <button v-if="payCashTurns" class="btn btn-primary mt-2 w-100" @click="bot()">Por Transferencia Bancaria</button>  
                    <button v-if="payMoneyTurns" class="btn btn-primary mt-2 w-100" @click="this.step = 7">Pagar en Efectivo</button>  
                    <!--<button class="btn btn-primary btn-lg mt-2 mb-5 w-100" @click="this.step = 2; this.ammount= ''">Abonar otro monto</button>-->
                    <button class="btn btn-link w-100" @click="closeSteps()">Cancelar</button>
                </div>
            </div>
        </div>
        <div class="form-pay-option" v-if="step == 2">
            <div>
                <h4>Ingresa el monto:</h4>
                <div tabindex="1" oncopy="return false" oncut="return false" onpaste="return false" class="motion_field" @keypress="whriteText($event)" @keydown="deleteText($event)" v-html="ammountHtml">   
                </div>
                <div class="keyboard">  
                    <button class="btn btn-outline-primary btn-lg" @click="whriteMText(1)">1</button>
                    <button class="btn btn-outline-primary btn-lg" @click="whriteMText(2)">2</button>
                    <button class="btn btn-outline-primary btn-lg" @click="whriteMText(3)">3</button>
                    <button class="btn btn-outline-primary btn-lg" @click="whriteMText(4)">4</button>
                    <button class="btn btn-outline-primary btn-lg" @click="whriteMText(5)">5</button>
                    <button class="btn btn-outline-primary btn-lg" @click="whriteMText(6)">6</button>
                    <button class="btn btn-outline-primary btn-lg" @click="whriteMText(7)">7</button>
                    <button class="btn btn-outline-primary btn-lg" @click="whriteMText(8)">8</button>    
                    <button class="btn btn-outline-primary btn-lg" @click="whriteMText(9)">9</button>
                    <button class="btn btn-outline-primary btn-lg" @click="deleteAll()"><i class="las la-eraser"></i></button>
                    <button class="btn btn-outline-primary btn-lg" @click="whriteMText(0)">0</button>   
                    <button class="btn btn-outline-primary btn-lg" @click="deleteMText()"><i class="las la-backspace"></i></button>        
                </div>
                <button class="btn btn-primary w-100" :disabled="disabledBtn" @click="this.step = 3">Confirmar</button>
                <button class="btn btn-link w-100" @click="closeSteps()">Cancelar</button>
            </div>
        </div>
        <div class="form-pay-option first" v-if="step == 3">
            <div>
                <div class="text-dark">
                    <h4>Confirma el pago</h4>     
                    <div v-if="userModeSel == 2">
                        <h4>De {{this.balances[0].title}} por</h4>
                    </div>
                    <div class="price"><span>{{currency}}</span> {{priceFormat}}</div>
                    <button v-if="userModeSel == 2" class="btn btn-primary w-100" @click="goToPasarela()">Proceder a pagar</button>
                    <button class="btn btn-link w-100" @click="closeSteps()">Cancelar</button>
                </div>
            </div>
        </div>
        <div class="form-pay-option first" v-if="step == 5">
            <div class="text-dark">
                <div>
                    <div class="card-body text-dark" v-if="showBankData">
                        <h5 class="text-center"><i class="las la-university"></i> Datos de la Cuenta</h5>
                        <p class="small fst-italic text-center">Una vez realizada la transferencia, envíale el comprobante al profesional desde el chat directo que cuentas en la plataforma.</p>
                        <div class="row">
                            <div class="col-md-12">
                                <p class="m-0"><b>Banco:</b></p>
                                <p class="m-0">{{bankName}}</p>
                                <p class="m-0">{{cbu}} <a @click="copyText('cbuInput')" title="Copiar" class="pointer text-primary"><i class="las la-clipboard"></i></a></p>
                                <input id="cbuInput" type="text" v-model="cbu" class="d-none">
                                <label v-if="userAliasBank != ''">Alias:</label>
                                <p v-if="userAliasBank != ''">{{userAliasBank}} <a @click="copyText('userAliasBank')" title="Copiar" class="pointer text-primary"><i class="las la-clipboard"></i></a></p>
                                <input id="userAliasBank" type="text" v-model="userAliasBank" class="d-none">
                            </div>
                            <div class="col-md-12">
                                <p class="m-0"><b>Titular:</b></p>
                                <p class="m-0">{{titular}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="card-body" v-if="!showBankData">
                        <p class="small fst-italic text-center">Deberás ponerte en contacto con el profesional desde el chat directo que cuentas en la plataforma para coordinar el pago.</p> 
                    </div>
                    <h5 class="text-center">Total a abonar:</h5>
                    <div class="price"><span>{{currency}}</span> {{priceFormat}}</div>

                    <button class="btn btn-primary w-100" @click="closeSteps()">Aceptar</button>
                </div>
                <div class="mx-auto position-fixed bottom-0 end-0 start-0 end-0 p-0 pt-3 pb-3" style="z-index: 20001; width: fit-content;">
                    <div id="toastcontainer2" class="w-25">
                    </div>
                </div>
            </div>
        </div>
        <div class="form-pay-option first" v-if="step == 6">
            <div>
                <div class="text-dark">
                    <div class="card-body">
                        <p class="small fst-italic text-center">Deberás ponerte en contacto con el profesional desde el chat directo que cuentas en la plataforma para que te active un medio de pago.</p> 
                    </div>
                    <h5 class="text-center">Total a abonar:</h5>
                    <div class="price"><span>{{currency}}</span> {{priceFormat}}</div>

                    <button class="btn btn-primary w-100" @click="closeSteps()">Aceptar</button>
                </div>
            </div>
        </div> 
        <div class="form-pay-option first" v-if="step == 7">
            <div>
                <div>
                    <div class="card-body">
                        <h4 class="text-center">Deberás abonar en efectivo el día de la cita.</h4> 
                    </div>
                    <h5 class="text-center">Total a abonar:</h5>
                    <div class="price"><span>{{currency}}</span> {{priceFormat}}</div>

                    <button class="btn btn-primary w-100" @click="closeSteps()">Aceptar</button>
                </div>
            </div>
        </div>
    </div>
    <div class="mx-auto position-fixed bottom-0 end-0 start-0 end-0 p-0 pt-3 pb-3" style="z-index: 20001; width: fit-content;">
        <div id="toastcontainer" class="w-25">
        </div>
    </div>
    <div class="payment-container" id="testPay" v-show="pay">
        <button id="closePaymentPopUp" class="btn btn-outline-light btn-close-popup" @click="pay=false; hidecontent = false"><i class="las la-times"></i></button>
        <iframe  :src="buttonPasarela"></iframe>
    </div>
</template>
<script>
import axios from "axios";
import { Toast } from 'bootstrap'
let url;
export default { 
    name: "balancesPayPublish",
    props: ['userSelected', 'userMode', 'showAll', 'showName', 'textButton', 'bookingId'],
    data(){
        return{
            errorText: '',
            toastColor: '',
            toastBg: '',
            toastNumber: 0,
            balances: [],
            wallets: [],
            userSel: this.userSelected,
            userModeSel: this.userMode,
            showAllSel: this.showAll,
            localZone: '',
            dataReceiver: '',
            clientCountry: '',
            sellerCountry: '',
            step: 0,
            ammount: '',
            ammountHtml: '<b class="new_char currency">$</b><b class="new_char">0</b>',
            ammountHtmlDel: '',
            countChar: 0,
            currency: '',
            priceFormat: '',
            positionArray: 0,
            pasarela: '',
            pay: false,
            hidecontent: false,
            publicKey: '',
            userName: '',
            sellerId: '',
            buttonPasarela: '',
            result: '',
            payCardTurns: true,
            payCashTurns: true,
            payMoneyTurns: true,
            enabledPayCard: false, //si no es de argentina mexico chile o usa y no configuro la pasarela se deshabilita      
            bankName: '',
            cbu: '',
            userAliasBank: '',
            doc: '',
            titular: '',
            showBankData: false,
            disabledBtn: true,
            tempBook: '',
            modality: 0,
            bookings: '',
            notShow: true
        }
    },
    mounted: function () {
        var data = JSON.parse(localStorage.getItem('userData'));
        this.clientCountry = data.userCountry;
        if(window.location.host == 'h.animasana.net' || window.location.host == 'animasana.net'){
            url = 'https://api.animasana.net'
        }else if(window.location.host == 'api-qa.animasana.net'){
            url = 'https://api-qa.animasana.net' 
        }else{
            url = 'https://api-qa.animasana.net'
        }   
        const plugin = document.createElement("script");
        plugin.setAttribute("src", "https://cdn.jsdelivr.net/npm/moment@2.27.0/min/moment.min.js");
        plugin.setAttribute("id", "momentScript");
        plugin.async = false;
        document.head.appendChild(plugin);
        const plugin2 = document.createElement("script");
        plugin2.setAttribute("src", "https://cdnjs.cloudflare.com/ajax/libs/moment-timezone/0.5.34/moment-timezone-with-data-10-year-range.js");
        plugin2.setAttribute("id", "momentScriptYears");
        plugin2.async = false;
        document.head.appendChild(plugin2);
        plugin.onload = () => {
            plugin2.onload = () => {
                this.localZone =  moment.tz.guess();
                if (localStorage.getItem("corporativeIn") !== null && localStorage.getItem("corporativeIn") !== "") {
                    this.dataReceiver = localStorage.getItem('corporativeIn');
                }else{
                    this.dataReceiver = localStorage.getItem('token');
                }     
                this.findBookings();
            }
        }       
    },
    methods:{
        copyText(val) {
            // Get the text field
            var copyText = document.getElementById(val);
            // Select the text field
            copyText.select();
            copyText.setSelectionRange(0, 99999); // For mobile devices
            // Copy the text inside the text field
            navigator.clipboard.writeText(copyText.value);

            this.errorText = 'Copiado al portapapeles.';
            this.toastBg = 'bg-success';
            this.toastColor = 'text-dark';
            this.toastNumber++;
            var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
            try{
                document.querySelector('#toastcontainer2').insertAdjacentHTML("afterend", t);
                var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                var bsAlert = new Toast(myAlert);//inizialize it
                bsAlert.show();//show it
            }catch(e){

            }
        },
        async findBookings(){  
            this.bankClass = '';
            this.booking = [];
            this.activeCard = '';
            var payload = {
                action: 'find-bookings',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                dataReceiver: this.dataReceiver, 
                mode: 2,
                next: 0,
                filter: 1,
                date: 'one',
                timezone: this.localZone,
                ref: this.bookingId
            }
            await axios.post('/index.php', payload).then(result => {
                this.bookings = result.data;
                this.modality = result.data[0].typeTurn;
                this.findSellerCountry(result.data[0].sellerId, result.data);
            })
            .catch(error => {
                this.errorText = 'Revise su conexión de internet.';
                this.toastBg = 'bg-danger';
                this.toastColor = 'text-dark';
                this.toastNumber++;
                var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                try{
                    document.querySelector('#toastcontainer').insertAdjacentHTML("afterend", t);
                    var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                    var bsAlert = new Toast(myAlert);//inizialize it
                    bsAlert.show();//show it
                }catch(e){

                }		
                return;
            })
        },
        async findSellerCountry(val, val2){   
            var payload = {
                action: 'find-user-data',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                dataReceiver: val,      
            }       
            await axios.post('/index.php', payload).then(result => {
                this.sellerCountry = result.data.userCountry;
                this.balances = val2;
                this.payByUser(this.balances[0].price, this.balances[0].currency, this.balances[0].pasarela, this.balances[0].price, this.balances[0].title, this.balances[0].sellerId)
            })
            .catch(error => {
               
            })     
        },
        payByUser(val, currency, pasarela, ammount, userName, sellerId){
            document.querySelector('html').style.overflow = 'hidden';
            this.deleteAll();
            this.positionArray = val;
            this.currency = currency;
            this.pasarela = pasarela;
            this.ammount = ammount;     
            var t = String(this.ammount).replace(/(.)(?=(\d{3})+$)/g,'$1.');
            this.priceFormat = t;   
            this.userName = userName;
            this.sellerId = sellerId;
            
            if(this.clientCountry == this.sellerCountry){
                this.findBankUserData(sellerId);
                this.findLobalPayments(sellerId); 
            }else{
                this.findGlobalPayments(sellerId);
            }   
        },
        async findBankUserData(val){
            var payload = {
                    action: 'find-user-bank',
                    browserCountry: this.$route.params.browserCountry,
                    userLang: this.$route.params.userLang,
                    urlcode: window.location.host,
                    dataReceiver: val    
                } 
                await axios.post('/index.php', payload)
                .then(result => {   
                    if(result.data.status == '200'){
                        this.bankName = result.data.bankName;
                        this.cbu = result.data.account;
                        this.doc = result.data.dni;
                        this.userAliasBank = result.data.userAliasBank;
                        this.titular =  result.data.name + ' ' + result.data.lastname;
                        this.showBankData = true; 
                        
                     }else{
                        this.showBankData = false; 
                     } 
                });
        },
        async findGlobalPayments(val){  
            var payload = {
                action: 'find-global-payments',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                dataReceiver: val
            }
            await axios.post('/index.php', payload)
            .then(result => {
                if(result.data.status == '200'){
                     if(result.data.secretKey == "" && result.data.publicKey == ""){
                        this.pasarela = 'stripe';
                        this.pasarela = 2;
                        this.pasarelaId = result.data.pasarela;
                        this.pasarelaCurrency = result.data.currency;
                     }else{
                         if(result.data.checked == true){
                            this.pasarela = 'payPal';
                            this.pasarela = 4;
                            this.secretKey = result.data.secretKey;
                            this.publicKey = result.data.publicKey;
                            this.pasarelaId = result.data.pasarela;
                            this.pasarelaCurrency = result.data.currency;
                         }else{
                            this.pasarela = 'stripe';
                            this.pasarela = 2;
                            this.pasarelaId = result.data.pasarela;
                            this.pasarelaCurrency = result.data.currency;
                         }
                     }
                } 
                this.findPaymentOptions(this.sellerId);
                
            })
            .catch(error => {
                this.loading = false;
                this.disabled = false;
                this.errorText = 'Revise su conexión de internet.';
                this.toastBg = 'bg-danger';
                this.toastColor = 'text-dark';
                this.toastNumber++;
                var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                try{
                    document.querySelector('#toastcontainer').insertAdjacentHTML("afterend", t);
                    var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                    var bsAlert = new Toast(myAlert);//inizialize it
                    bsAlert.show();//show it
                }catch(e){

                }	
                return;
            })
        },
        async findLobalPayments(val){  
            var payload = {
                action: 'find-local-payments',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                dataReceiver: val
            }
            await axios.post('/index.php', payload)
            
            .then(result => {
                if(result.data.status == '200'){
                    this.pasarela = result.data.pasarela;
                     if(result.data.secretKey == "" && result.data.publicKey == ""){ //si no tiene las keys
                        //si son de los paises que animasana cuenta con pasarela
                        if(result.data.userCountry == '42' || result.data.userCountry == '81' || result.data.userCountry == '55'){
                            this.pasarela = 1;
                            this.enabledPayCard = true;
                        }else if(result.data.userCountry == '55'){ 
                            this.pasarela = 2;
                            this.enabledPayCard = true;
                        }else{
                            this.enabledPayCard = false;
                        }
                     }else{
                        //si tiene las keys
                         if(result.data.checked == true){ //si esta chequeadas las keys
                            this.publicKey = result.data.publicKey;
                            this.enabledPayCard = true;
                         }else{
                            //si no estan chequeadas
                            //si son de los paises de animasana no pasa nada 
                            if(result.data.userCountry == '42' || result.data.userCountry == '81' || result.data.userCountry == '55'){
                                this.pasarela = 1;
                                this.enabledPayCard = true;
                            }else if(result.data.userCountry == '55'){ 
                                this.pasarela = 2;
                                this.enabledPayCard = true;
                            }else{
                                //sino se desactiva la pasarela de tarjetas
                                this.enabledPayCard = false;
                            }   
                         }
                     } 
                     if(this.contactCountry != result.data.userCountry){ 
                        this.payCardTurns = true;
                        this.payCardTurns = false;
                        this.payMoneyTurns = false;
                     }
                     if(this.modality == '1'){
                        this.payMoneyTurns = false;      
                     }  
                }   
                this.findPaymentOptions(this.sellerId);
            })
            .catch(error => {
                this.loading = false;
                this.disabled = false;
                this.errorText = 'Revise su conexión de internet.';
                this.toastBg = 'bg-danger';
                this.toastColor = 'text-dark';
                this.toastNumber++;
                var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                try{
                    document.querySelector('#toastcontainer').insertAdjacentHTML("afterend", t);
                    var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                    var bsAlert = new Toast(myAlert);//inizialize it
                    bsAlert.show();//show it
                }catch(e){

                }		
                return;
            })
        },
        closeSteps(){
            this.step = 0;
            document.querySelector('html').style.overflow = 'auto';
            this.$parent.absolutePayOption();
        },
        async findPaymentOptions(val){    
            var payload = {
                action: 'find-user-payment-options',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                mode: this.userModeSel,     
                dataReceiver: this.dataReceiver,
                balanceOfUser: val,    
            }
            await axios.post('/index.php', payload).then(result => {
                if(result.data.status == '200'){
                    if(result.data.payCash == 0){
                         this.payCashTurns = false;
                    }else{
                        this.payCashTurns = true;
                    }
                    if(result.data.payMoney == 0){
                         this.payMoneyTurns = false;
                    }else{
                        this.payMoneyTurns = true;
                    }
                    if(result.data.payCard == 0){
                         this.payCardTurns = false;
                    }else{   
                        
                        if(this.enabledPayCard == true){   
                            this.payCardTurns = true;     
                        }else{
                            if(this.currency == 'USD'){
                                this.payCardTurns = true;
                                //this.pasarela = 2;
                            }else{
                                this.payCardTurns = false;
                            }
                        }
                    }
                    if(this.notShow){
                        return
                    }

                    if(this.bookings[0].createByProf == '0'){
                        if(this.bookings[0].payCash == 0){
                            this.payCashTurns = false;
                        }else{
                            this.payCashTurns = true;
                        }
                        if(this.bookings[0].payCard == 0){
                            this.payCardTurns = false;
                        }else{
                            this.payCardTurns = true;
                        }
                    }
                    if(this.bookings[0].modalityId == '1'){
                        this.payMoneyTurns = false;
                    }
                    
                    document.querySelector('html').style.overflow = 'hidden';
                    if(this.payCashTurns == true && this.payCardTurns == true && this.payMoneyTurns == true){
                        this.step = 1;
                    }else if(this.payCashTurns == false && this.payMoneyTurns == true && this.payCardTurns == true){
                        this.step = 1;
                    }else if(this.payCashTurns == true && this.payMoneyTurns == false && this.payCardTurns == true){
                        this.step = 1;
                    }else if(this.payCashTurns == true && this.payMoneyTurns == true && this.payCardTurns == false){
                        this.step = 1;
                    }else if(this.payCashTurns == false && this.payMoneyTurns == false && this.payCardTurns == true){
                        this.step = 3;
                    }else if(this.payCashTurns == true && this.payMoneyTurns == false && this.payCardTurns == false){
                        this.step = 5;
                    }else if(this.payCashTurns == false && this.payCardTurns == false && this.payMoneyTurns == false){  
                        this.step = 6;
                    }else if(this.payCashTurns == false && this.payMoneyTurns == true && this.payCardTurns == false){
                        this.step = 7;
                    }    
                    this.$parent.absolutePayOption();   
                }
            })
            .catch(error => {
                this.errorText = 'Revise su conexión de internet.';
                this.toastBg = 'bg-danger';
                this.toastColor = 'text-dark';
                this.toastNumber++;
                var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                try{
                    document.querySelector('#toastcontainer').insertAdjacentHTML("afterend", t);
                    var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                    var bsAlert = new Toast(myAlert);//inizialize it
                    bsAlert.show();//show it
                }catch(e){

                }			
                return;
            })
        },
        
        reset(val){
            if(window.location.host == 'h.animasana.net' || window.location.host == 'animasana.net'){
                location.href = 'https://'+window.location.host +'/'+ this.$route.params.browserCountry+'/'+ this.$route.params.userLang +'/'+val;
            }else if(window.location.host == 'api-qa.animasana.net'){
                location.href = 'https://'+window.location.host +'/'+ this.$route.params.browserCountry+'/'+ this.$route.params.userLang +'/'+val;
            }else{
                location.href = 'http://'+window.location.host +'/'+ this.$route.params.browserCountry+'/'+ this.$route.params.userLang +'/'+val;
            }      
        }, 
        goToPasarela(){
            if(this.pasarela == '3'){
                this.mercadoPago();
            }else if(this.pasarela == '4'){
                this.payPal();
            }else if(this.pasarela == '2'){
                this.stripe();
            }else if(this.pasarela == '1'){
                this.dLocal();
            }
            localStorage.setItem('manualPay', JSON.stringify({currency: this.currency, ammount: this.ammount, sellerId: this.sellerId, clientId: this.dataReceiver, localZone: this.localZone, pasarela: this.pasarela, publicKey: this.publicKey, bookingId: this.bookingId}));
        },
        async payPal(){  
            this.buttonPasarela = url + '/pasarelas/paypal-option.php?browserCountry='+this.$route.params.browserCountry
            +'&userLang='+this.$route.params.userLang+'&urlcode='+window.location.host+'&dataReceiver='+this.sellerId+'&item='+localStorage.getItem('token')+'&price='+this.ammount+'&currency='+this.currency
            +'&publicKey='+this.publicKey+'&pasarela='+this.pasarela+'&back='+window.location.href+"&description="+this.userName+"&short=Animasana"+'&tempBook='+this.tempBook+'&payReservedId='+this.bookingId+'&mode=2';

            this.pay = true;
            this.hidecontent = true;
            document.querySelector('html').classList.add('overflow-hidden');          
        },
        async mercadoPago(){
            this.buttonPasarela = url + '/pasarelas/mp-option.php?browserCountry='+this.$route.params.browserCountry
            +'&userLang='+this.$route.params.userLang+'&urlcode='+window.location.host+'&dataReceiver='+this.sellerId+'&item='+localStorage.getItem('token')+'&price='+this.ammount+'&currency='+this.currency
            +'&publicKey='+this.publicKey+'&pasarela='+this.pasarela+'&back='+window.location.href+"&description="+this.userName+"&short=Animasana"+'&tempBook='+this.tempBook+'&payReservedId='+this.bookingId+'&mode=2';
            this.pay = true;
            this.hidecontent = true;
            document.querySelector('html').classList.add('overflow-hidden');          
        },
        async stripe(){
            this.buttonPasarela = url + '/pasarelas/stripe-manual-option.php?browserCountry='+this.$route.params.browserCountry
            +'&userLang='+this.$route.params.userLang+'&urlcode='+window.location.host+'&dataReceiver='+this.sellerId+'&item='+localStorage.getItem('token')+'&price='+this.ammount+'&currency='+this.currency
            +'&publicKey='+this.publicKey+'&pasarela='+this.pasarela+'&back='+window.location.href+"&description="+this.userName+"&short=Animasana"+'&tempBook='+this.tempBook+'&payReservedId='+this.bookingId+'&mode=2';
            this.pay = true;
            this.hidecontent = true;
            document.querySelector('html').classList.add('overflow-hidden');          
        },
        async dLocal(){  
            this.buttonPasarela = url + '/pasarelas/dlocal-option.php?browserCountry='+this.$route.params.browserCountry+'&userLang=es'+'&urlcode='+window.location.host+'&dataReceiver='+this.sellerId+'&item='+localStorage.getItem('token')+'&price='+this.ammount+'&currency='+this.currency
                +'&publicKey='+this.publicKey+'&pasarela='+this.pasarela+'&back='+window.location.href+"&description="+this.userName+"&short=Animasana"+'&tempBook='+this.tempBook+'&payReservedId='+this.bookingId+'&mode=2';

            this.pay = true;
            this.hidecontent = true;
            document.querySelector('html').classList.add('overflow-hidden');          
        },
        deleteAll(){
            this.ammount = '';
            this.ammountHtml = '<b class="new_char currency">$</b><b class="new_char">0</b>';
            this.ammountHtmlDel = '';
            this.countChar = 0;
            if(this.ammount == ""){
                this.disabledBtn = true;
            }else{
                this.disabledBtn = false;
            }
        },
         whriteMText(event) {    
            if(this.countChar < 7){
                if(this.countChar == 0 && event != 0){
                    this.ammountHtml = '<b class="new_char currency">$</b>';
                }
                if(this.countChar == 0 && event == 0){
                    return;
                }
                this.ammount = this.ammount + event;
                this.countChar++;  
                var t = String(this.ammount).replace(/(.)(?=(\d{3})+$)/g,'$1.');
                this.priceFormat = t;
                t = t.split('');
                var p = '<b class="new_char currency">$</b>';

                [].forEach.call(t, function(el) {
                    p = p + '<b class="new_char">' + el + '</b>';
                });
                this.ammountHtml = p;
            } 
            if(this.ammount == ""){
                this.disabledBtn = true;
            }else{
                this.disabledBtn = false;
            }
        },
        whriteText(event) {
            if (event.keyCode != 13) {
                if (event.keyCode == 48 || event.keyCode == 49 || event.keyCode == 50 || event.keyCode == 51 || event.keyCode == 52 || event.keyCode == 53 || event.keyCode == 54 || event.keyCode == 55 || event.keyCode == 56 || event.keyCode == 57) {
                    if(this.countChar < 7){
                        if(this.countChar == 0 && event.keyCode != 48){
                            this.ammountHtml = '<b class="new_char currency">$</b>';
                        }
                        if(this.countChar == 0 && event.keyCode == 48){
                            return;
                        }
                        var str = String.fromCharCode(event.keyCode);
                        this.ammount = this.ammount + str;
                        this.countChar++;      
                        var t = String(this.ammount).replace(/(.)(?=(\d{3})+$)/g,'$1.');
                        this.priceFormat = t;
                        t = t.split('');
                        var p = '<b class="new_char currency">$</b>';

                        [].forEach.call(t, function(el) {
                            p = p + '<b class="new_char">' + el + '</b>';
                        });
                        this.ammountHtml = p;
                    }
                }
            }
            if(this.ammount == ""){
                this.disabledBtn = true;
            }else{
                this.disabledBtn = false;
            }
        },
        deleteMText(){
            this.ammount = this.ammount.slice(0, -1)
            var t = String(this.ammount).replace(/(.)(?=(\d{3})+$)/g,'$1.');
            this.priceFormat = t;
            t = t.split('');
            var p = '<b class="new_char currency">$</b>';

            [].forEach.call(t, function(el) {
                p = p + '<b class="new_char">' + el + '</b>';
            });
            this.ammountHtml = p;
            this.countChar--;
            if(this.countChar <= 0){
                this.countChar = 0;
                if(this.countChar == 0){  
                    this.ammountHtml = '<b class="new_char currency">$</b><b class="new_char">0</b>';
                }
            }
            if(this.ammount == ""){
                this.disabledBtn = true;
            }else{
                this.disabledBtn = false;
            }
        },
        deleteText(e){
            if (e.keyCode == 8 || e.keyCode == 46) {
                e.preventDefault();
                this.ammount = this.ammount.slice(0, -1)
                var t = String(this.ammount).replace(/(.)(?=(\d{3})+$)/g,'$1.');
                this.priceFormat = t;
                t = t.split('');
                var p = '<b class="new_char currency">$</b>';

                [].forEach.call(t, function(el) {
                    p = p + '<b class="new_char">' + el + '</b>';
                });
                this.ammountHtml = p;
                this.countChar--;
                if(this.countChar <= 0){
                    this.countChar = 0;
                    if(this.countChar == 0){  
                        this.ammountHtml = '<b class="new_char currency">$</b><b class="new_char">0</b>';
                    }
                }
                
            }
            if(this.ammount == ""){
                this.disabledBtn = true;
            }else{
                this.disabledBtn = false;
            }
        },
        bot(){
            if(window.location.host == 'h.animasana.net' || window.location.host == 'animasana.net'){
                this.whatsAppClient = '541169645225';
            }else if(window.location.host == 'qa.front-ews.pages.dev'){
                this.whatsAppClient = '541135109050';
            }else{
                this.whatsAppClient = '541135109050';
            }
            if(this.bookings[0].date != ''){
                location.href = 'https://api.whatsapp.com/send?phone=' + this.whatsAppClient + '&text=Quisiera%20abonar%20mi%20'+this.textButton+'%20del%20' + this.bookings[0].date + '%20a%20las%20' + this.bookings[0].hourStartClient
            }else{
                location.href = 'https://api.whatsapp.com/send?phone=' + this.whatsAppClient + '&text=Quisiera%20abonar%20mi%20'+this.textButton
            }
            
        }

    }
}
</script>
<style scoped>
.balance .form-pay-option{

    height: 100%;

}
</style>